import { render, staticRenderFns } from "./XPAlert.vue?vue&type=template&id=0771eee3&scoped=true"
import script from "./XPAlert.vue?vue&type=script&lang=js"
export * from "./XPAlert.vue?vue&type=script&lang=js"
import style0 from "./XPAlert.vue?vue&type=style&index=0&id=0771eee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771eee3",
  null
  
)

export default component.exports